import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import {
  getDecryptID,
  isEmptyObject,
  clusterCalculations,
  formatDigits,
  customParse,
  parseFloatCustom
} from '../../appRedux/actions/GlobalMethods'
import { Table, Button, Row, Col, Form, Popover } from 'antd'
import {
  loadIsPromoCodePopoverVisible,
  loadIsTaxPopoverVisible,
  loadIsPromotionPopoverVisible,
  loadIsDiscountPopoverVisible,
  loadIsPaymentPopoverVisible
} from '../../appRedux/actions/MainSale'
import { SellProductJsonBuilder } from '../../appRedux/actions/SellScreenMethods'
import { SALE_ACTION_LOG } from '../../constants/StoreSetting'
import { fetchCurrentSalesOrder, loadActionLogs } from '../../appRedux/actions'

const Tax = props => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: '',
        currencyName: '',
        currencySymbol: ''
      }

  const getStoredBooks = useSelector(({ Sell }) => Sell.salePriceBooks)
  const getStoredPromos = useSelector(({ Sell }) => Sell.salePromotions)
  const getSelectedReg = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedReggg
  )
  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getIsTaxPopoverVisible = useSelector(
    ({ MainSale }) => MainSale.getIsTaxPopoverVisible
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getBasicIsPercent = useSelector(
    ({ MainSale }) => MainSale.getBasicIsPercent
  )
  const getTableDataSellTax = useSelector(
    ({ MainSale }) => MainSale.getTableDataSellTax
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getCustomerSearchData = useSelector(
    ({ Sell }) => Sell.customerSearchData
  )
  const getIsLoyaltyEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsLoyaltyEnabled
  )
  const getDefaultLoyaltyAmount = useSelector(
    ({ MainSale }) => MainSale.getDefaultLoyaltyAmount
  )
  const getSelectedOutlet = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedOutlet
  )
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )
  const getSavings = useSelector(({ MainSale }) => MainSale.getTotalSaving)
  const sellActionLog = useSelector(({ Sell }) => Sell.sellActionLog)
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)

  const [getTotalTax, setTotalTax] = useState('')

  const formDiscPer = useSelector(({ MainSale }) => MainSale.formDiscPer)
  const formDiscCurr = useSelector(({ MainSale }) => MainSale.formDiscCurr)
  const formSellNote = useSelector(({ MainSale }) => MainSale.formSellNote)
  const getRefundKeys = useSelector(({ MainSale }) => MainSale.getRefundKeys)

  // React.useEffect(() => {
  //   let mounted = true;
  //   if (mounted) {
  //     const tax = getTableDataSellTax && getTableDataSellTax.length > 0 ?
  //       getTableDataSellTax.reduce((a, v) => (a = a + v.sellTaxPrice), 0) : 0;
  //     const taxDec = formatDigits(tax, getDefaultDecimalPlaces);
  //     setTotalTax(taxDec);
  //   }

  //   return () => mounted = false;
  // }, [getTableDataSellTax]);

  const columnsSellTax = [
    {
      title: false,
      dataIndex: 'sellTaxName',
      key: 'sellTaxName',
      render: (text, record) => {
        return (
          <div className='sale-total-line-item--sub custom-inline'>
            <p className='custom-font-size-weight custom-inline'>
              {`${record.sellTaxName} ${
                record.isFix ? record.fixRate : record.sellTaxRate * 100
              }
              ${record.isFix ? ' FIX' : '%'}`}
              {/* ${record.isFix ? ` ${getCurrData && getCurrData.currencyCode ? getCurrData.currencyCode : "FIXED"}` : "%"}`} */}
            </p>
          </div>
        )
      }
    },
    {
      title: false,
      dataIndex: 'sellTaxPrice',
      key: 'sellTaxPrice',
      render: (text, record) => {
        return (
          <p className='custom-font-size-weight custom-font-color-black custom-mg-bt-0'>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}
            {record.sellTaxPrice
              ? formatDigits(record.sellTaxPrice, getDefaultDecimalPlaces)
              : '0.00'}
          </p>
        )
      }
    },
    {
      // title: <IntlMessages id="products.suppliers.delete" />,
      dataIndex: 'key',
      key: 'key',
      render: (text, record) => {
        function setActionLog (identify) {
          const comment = `The Tax ${formatDigits(
            record.sellTaxPrice,
            getDefaultDecimalPlaces
          )} was removed by ${
            getReduxStoreInfo && getReduxStoreInfo.userName
              ? getReduxStoreInfo.userName
              : 'XXX'
          } with userID of ${
            getReduxStoreInfo && getReduxStoreInfo.userID
              ? getDecryptID(getReduxStoreInfo.userID)
              : ''
          }`
          const body = {
            ActionBy:
              getReduxStoreInfo && getReduxStoreInfo.userID
                ? getReduxStoreInfo.userID
                : '',
            Comment: comment,
            FromValue: parseFloatCustom(record.sellTaxPrice),
            ToValue: 0,
            SaleActionLogTypeId: `${identify}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
            key: ''
          }
          const data =
            sellActionLog && sellActionLog.length > 0 ? sellActionLog : []
          dispatch(loadActionLogs(data.concat(body)))
        }
        const removeItem = taxID => {
          setActionLog(SALE_ACTION_LOG.RemoveTax)
          let items = getReduxSaleProductJsonData
          items.forEach(function (obj) {
            obj.taxComponents = obj.taxComponents.filter(
              s => getDecryptID(s.taxId) != getDecryptID(taxID)
            )
            if (obj.productSellTaxes && obj.productSellTaxes.length > 0) {
              obj.productSellTaxes = obj.productSellTaxes.filter(
                ss => getDecryptID(ss.sTaxID) != getDecryptID(taxID)
              )
            }
            if (obj.taxesRevisionList && obj.taxesRevisionList.length > 0) {
              obj.taxesRevisionList = obj.taxesRevisionList.filter(
                sse => getDecryptID(sse.taxID) != getDecryptID(taxID)
              )
            }
            obj.tax_id = ''
            obj.taxName = ''
            obj.baseTax = 0
          })

          if (items && items.length > 0) {
            let prdsFddler = getReduxSaleProductJsonData
            items.map(item => {
              const productsClone = SellProductJsonBuilder(
                item,
                undefined,
                '',
                getCustomerSearchData,
                getReduxSaleProductJsonData,
                getStoredBooks,
                getIsLoyaltyEnabled,
                getDefaultLoyaltyAmount,
                getIsTaxExclusive,
                getStoredPromos,
                getDefaultDecimalPlaces,
                getSelectedOutlet,
                getSelectedReg,
                getBasicIsPercent,
                getIsRefundSale,
                getCurrentSalesOrderData,
                getCurrentSalesOrderStatusID,
                formDiscCurr,
                formDiscPer,
                formSellNote,
                getRefundKeys,
                getSalePayments,
                dispatch,
                false,
                getSavings,
                'Tax',
                false,
                sellSelAttributes
              )
              if (productsClone && !isEmptyObject(productsClone)) {
                if (
                  productsClone.key &&
                  prdsFddler.filter(a => a.key === productsClone.key)[0]
                ) {
                  let index = prdsFddler.indexOf(
                    prdsFddler.filter(a => a.key == productsClone.key)[0]
                  )
                  prdsFddler[index] = productsClone
                } else {
                  prdsFddler = prdsFddler.concat(productsClone)
                }
              }
            })
            clusterCalculations(
              prdsFddler,
              getSelectedOutlet,
              getSelectedReg,
              getBasicIsPercent,
              getCustomerSearchData,
              getIsRefundSale,
              getDefaultDecimalPlaces,
              getCurrentSalesOrderData,
              getCurrentSalesOrderStatusID,
              formDiscCurr,
              formDiscPer,
              formSellNote,
              getRefundKeys,
              getSalePayments,
              dispatch,
              getStoredPromos,
              getIsTaxExclusive,
              false,
              getSavings,
              sellSelAttributes
            )
          }
        }
        return (
          <span>
            {!getIsRefundSale &&
              getDecryptID(getCurrentSalesOrderStatusID) !=
                getDecryptID(fetchCurrentSalesOrder('LayBy')) &&
              getDecryptID(getCurrentSalesOrderStatusID) !=
                getDecryptID(fetchCurrentSalesOrder('On Account')) && (
                <a className='trash-icon-btn'>
                  <i
                    className='icon icon-trash'
                    onClick={() => removeItem(record.key)}
                  />
                </a>
              )}
          </span>
        )
      }
    }
  ]

  const taxTitle = (
    <p className='custom-font-size-weight custom-font-color-black dk-pt3 dk-mgb-10 dk-text-center'>
      <IntlMessages id='sell.sell.removetaxfromsale' />
    </p>
  )
  const taxContent = (
    <div className='dk-mgt-3'>
      <Table
        className='gx-table-responsive custom-sell-table'
        columns={columnsSellTax}
        dataSource={getTableDataSellTax}
        pagination={false}
      />
      <div className='dk-flex dk-discount-popover-footer dk-pt3 dk-pb3 '>
        <Button
          className='dk-btn-cancel dk-mgr-19'
          type='primary'
          onClick={() => {
            handlePromotionVisibleChange(false)
          }}
        >
          <IntlMessages id='sell.sell.close' />
        </Button>
      </div>
    </div>
  )

  const handlePromotionVisibleChange = isPopOverVisible => {
    // setIsPromotionPopoverVisible(isPopOverVisible);
    dispatch(loadIsPromotionPopoverVisible(isPopOverVisible))
    // setIsDiscountPopoverVisible(false);
    dispatch(loadIsDiscountPopoverVisible(false))
    // setIsTaxPopoverVisible(false);
    dispatch(loadIsTaxPopoverVisible(false))
    // setIsPromoCodePopoverVisible(false);
    dispatch(loadIsPromoCodePopoverVisible(false))
    // setIsPaymentPopoverVisible(false);
    dispatch(loadIsPaymentPopoverVisible(false))
  }

  const handleTaxVisibleChange = isPopOverVisible => {
    // setIsTaxPopoverVisible(isPopOverVisible);
    dispatch(loadIsTaxPopoverVisible(isPopOverVisible))
    // setIsPromotionPopoverVisible(false);
    dispatch(loadIsPromotionPopoverVisible(false))
    // setIsDiscountPopoverVisible(false);
    dispatch(loadIsDiscountPopoverVisible(false))
    // setIsPromoCodePopoverVisible(false);
    dispatch(loadIsPromoCodePopoverVisible(false))
    // setIsPaymentPopoverVisible(false);
    dispatch(loadIsPaymentPopoverVisible(false))
  }

  return (
    <Row className='sale-list-footer-item-1 cart-sl'>
      <Col md={16} xs={16} sm={12}>
        <Popover
          placement='left'
          title={taxTitle}
          content={taxContent}
          trigger='click'
          visible={getIsTaxPopoverVisible}
          overlay={Popover}
          overlayClassName='customer-sell-taxpopover'
          //  getPopupContainer={trigger => trigger.parentElement}
          style={{ top: `${275 * getReduxSaleProductJsonData}px` }}
        >
          <p
            className='custom-font-size-weight custom-inline dk-link'
            onClick={() => {
              handleTaxVisibleChange(true)
            }}
          >
            <IntlMessages id='sell.sell.tax' />
          </p>
        </Popover>

        <div className='sale-total-line-item--sub custom-inline'>
          <p className='custom-font-size-weight custom-inline'>
            {getTableDataSellTax && getTableDataSellTax.length > 1 && (
              <>
                {`${getTableDataSellTax.length} `}
                <IntlMessages id='sell.sell.taxes' />
              </>
            )}
          </p>
        </div>

        <div className='sale-total-line-item--sub custom-inline'>
          <p className='custom-font-size-weight custom-inline'>
            {getTableDataSellTax && getTableDataSellTax.length == 1 && (
              <>
                {`${
                  getTableDataSellTax[0].sellTaxName
                    ? getTableDataSellTax[0].sellTaxName
                    : ''
                }`}
                {getTableDataSellTax[0].isFix
                  ? `${
                      getTableDataSellTax[0].fixRate
                        ? ` ${getTableDataSellTax[0].fixRate} ${
                            getCurrData.currencyCode != null
                              ? getCurrData.currencyCode
                              : ''
                          } FIXED`
                        : '0.00'
                    }`
                  : `${
                      getTableDataSellTax[0].sellTaxRate
                        ? getTableDataSellTax[0].sellTaxRate * 100
                        : ' 0.00'
                    }%`}
              </>
            )}
          </p>
        </div>
      </Col>

      <Col md={8} xs={8} sm={12}>
        {/* class--mb-0 */}
        <p className='custom-font-size-weight custom-font-color-black mb-0 text-rite'>
          {getCurrData.currencyCode != null
            ? getCurrData.currencyCode
            : getCurrData.currencyName != null
            ? getCurrData.currencyName
            : getCurrData.currencySymbol}{' '}
          {getTableDataSellTax && getTableDataSellTax != undefined
            ? formatDigits(
                getTableDataSellTax.reduce(
                  (a, v) => (a = a + v.sellTaxPrice),
                  0
                ),
                getDefaultDecimalPlaces
              )
            : '0.00'}
          {/* {getTotalTax} */}
        </p>
      </Col>
    </Row>
  )
}

export default Tax
